import { useState, useEffect } from 'react';

export default function HomePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://satisfyer.conejox.com.es';

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Schema.org structured data
  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Satisfyer Pro 2 Next Generation",
    "description": "Succionador de clítoris con tecnología de ondas de presión de aire. Silencioso, resistente al agua y con 11 niveles de intensidad.",
    "image": "https://public.readdy.ai/ai/img_res/18821062-5580-489b-bd88-b2fb95f30ddd.png",
    "brand": {
      "@type": "Brand",
      "name": "Satisfyer"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "15000"
    },
    "offers": {
      "@type": "Offer",
      "url": `${siteUrl}/`,
      "availability": "https://schema.org/InStock",
      "price": "49.99",
      "priceCurrency": "EUR"
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "¿Hace ruido?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No, es muy silencioso. Puedes usarlo incluso con gente cerca sin preocuparte. El motor está diseñado para ser ultra discreto."
        }
      },
      {
        "@type": "Question",
        "name": "¿Es fácil de limpiar?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Sí, solo retira el cabezal y lávalo con agua y jabón neutro. Al ser resistente al agua, la limpieza es súper sencilla e higiénica."
        }
      },
      {
        "@type": "Question",
        "name": "¿Duele si nunca he usado uno?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No, es una estimulación suave y sin contacto directo, perfecta incluso para principiantes. Empieza con el nivel más bajo y ve subiendo a tu ritmo."
        }
      },
      {
        "@type": "Question",
        "name": "¿Viene con cargador?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Sí, incluye cable USB para recargar fácilmente. Compatible con cualquier adaptador USB estándar o puerto de ordenador."
        }
      }
    ]
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Conejox",
    "url": siteUrl,
    "description": "Tu guía de confianza para productos de bienestar íntimo y placer femenino",
    "publisher": {
      "@type": "Organization",
      "name": "Conejox",
      "logo": {
        "@type": "ImageObject",
        "url": "https://public.readdy.ai/ai/img_res/18821062-5580-489b-bd88-b2fb95f30ddd.png"
      }
    }
  };

  // Update document head using React 19 features
  useEffect(() => {
    // Add JSON-LD schemas
    const schemas = [productSchema, faqSchema, websiteSchema];
    const scriptElements: HTMLScriptElement[] = [];

    schemas.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      scriptElements.push(script);
    });

    // Cleanup
    return () => {
      scriptElements.forEach(script => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img 
            src="https://static.readdy.ai/image/ddc6a6c51837b652ebd36d1bdad447b7/46b1584de23d253b2ff9eeaf480f7da2.jpeg"
            alt="Hero Background"
            className="w-full h-full object-cover object-center"
            loading="eager"
            fetchpriority="high"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
        </div>
        
        {/* Logo */}
        <div className="absolute top-4 left-4 sm:top-8 sm:left-8 z-20">
          <img 
            src="https://public.readdy.ai/ai/img_res/18821062-5580-489b-bd88-b2fb95f30ddd.png" 
            alt="Conejox Logo" 
            className="h-8 sm:h-12 w-auto object-contain drop-shadow-2xl"
            width="120"
            height="48"
            loading="eager"
            fetchpriority="high"
          />
        </div>

        <div className="container mx-auto px-4 sm:px-6 py-20 relative z-10 w-full">
          <div className="max-w-4xl mx-auto text-center">
            <div className="mb-6 sm:mb-8 inline-block">
              <span className="px-4 sm:px-6 py-2 bg-fuchsia-600 text-white text-xs sm:text-sm font-semibold rounded-full shadow-lg">
                #1 Más Vendido en el Mundo
              </span>
            </div>
            
            <h1 className="text-3xl sm:text-5xl md:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight px-2" style={{ textShadow: '0 4px 20px rgba(0,0,0,0.8), 0 2px 8px rgba(0,0,0,0.9)' }}>
              Tu nuevo ritual de placer<br />
              <span className="text-white">
                en un solo clic
              </span>
            </h1>
            
            <p className="text-base sm:text-xl md:text-2xl text-white mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed px-4" style={{ textShadow: '0 3px 15px rgba(0,0,0,0.8), 0 2px 6px rgba(0,0,0,0.9)' }}>
              El Satisfyer Pro 2 es el succionador más vendido del mundo. Silencioso, sin contacto y diseñado para orgasmos inolvidables.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center mb-8 sm:mb-12 px-4">
              <a 
                href="https://amzn.to/4s8i8sI" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="group w-full sm:w-auto px-6 sm:px-10 py-4 sm:py-5 bg-gradient-to-r from-fuchsia-600 to-pink-600 text-white text-base sm:text-lg font-bold rounded-full shadow-2xl hover:shadow-fuchsia-500/50 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer text-center"
              >
                Comprar ahora en Amazon
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform inline-block"></i>
              </a>
              
              <button 
                onClick={() => document.getElementById('video-section')?.scrollIntoView({ behavior: 'smooth' })}
                className="w-full sm:w-auto px-6 sm:px-10 py-4 sm:py-5 bg-white text-fuchsia-600 text-base sm:text-lg font-bold rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 border-2 border-fuchsia-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>
                Ver cómo funciona
              </button>
            </div>

            <div className="flex flex-wrap justify-center gap-4 sm:gap-8 text-xs sm:text-sm text-white px-4">
              <div className="flex items-center gap-2 bg-black/20 backdrop-blur-sm px-3 py-2 rounded-full">
                <i className="ri-shield-check-line text-white text-lg sm:text-xl flex-shrink-0"></i>
                <span className="whitespace-nowrap">Envío rápido y discreto</span>
              </div>
              <div className="flex items-center gap-2 bg-black/20 backdrop-blur-sm px-3 py-2 rounded-full">
                <i className="ri-star-fill text-white text-lg sm:text-xl flex-shrink-0"></i>
                <span className="whitespace-nowrap">Miles de reseñas positivas</span>
              </div>
              <div className="flex items-center gap-2 bg-black/20 backdrop-blur-sm px-3 py-2 rounded-full">
                <i className="ri-lock-line text-white text-lg sm:text-xl flex-shrink-0"></i>
                <span className="whitespace-nowrap">Compra 100% segura</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Intro */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6 sm:mb-8 px-2">
              Una revolución en placer femenino
            </h2>
            <p className="text-base sm:text-xl text-gray-700 leading-relaxed mb-4 sm:mb-6 px-4">
              El <strong>Satisfyer Pro 2</strong> utiliza tecnología de <strong>ondas de presión de aire</strong> que estimulan el clítoris sin contacto directo. Es como una caricia invisible que te lleva al clímax de forma suave, intensa y completamente única.
            </p>
            <p className="text-base sm:text-xl text-gray-700 leading-relaxed px-4">
              Millones de mujeres en todo el mundo ya lo han probado. Ahora es tu turno de descubrir por qué se ha convertido en el juguete íntimo más deseado y recomendado.
            </p>
          </div>
        </div>
      </section>

      {/* Key Benefits */}
      <section className="py-12 sm:py-20 bg-gradient-to-br from-fuchsia-50 to-pink-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center text-gray-900 mb-10 sm:mb-16 px-2">
              5 razones para enamorarte del Satisfyer Pro 2
            </h2>
            
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {/* Benefit 1 */}
              <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-fuchsia-500 to-pink-500 rounded-2xl flex items-center justify-center mb-4 sm:mb-6 text-2xl sm:text-3xl">
                  ✨
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                  Estímulo sin contacto
                </h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Tecnología de ondas de aire que miman el clítoris sin tocarlo. Una sensación completamente nueva y adictiva.
                </p>
              </div>

              {/* Benefit 2 */}
              <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-fuchsia-500 to-pink-500 rounded-2xl flex items-center justify-center mb-4 sm:mb-6 text-2xl sm:text-3xl">
                  🔇
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                  Silencioso y discreto
                </h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Ideal para usar sin que nadie lo note. Tu secreto mejor guardado para momentos de placer absoluto.
                </p>
              </div>

              {/* Benefit 3 */}
              <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-fuchsia-500 to-pink-500 rounded-2xl flex items-center justify-center mb-4 sm:mb-6 text-2xl sm:text-3xl">
                  💗
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                  Diseño ergonómico y sensual
                </h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Cómodo, bonito y fácil de sostener. Un diseño pensado para tu comodidad y placer máximo.
                </p>
              </div>

              {/* Benefit 4 */}
              <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-fuchsia-500 to-pink-500 rounded-2xl flex items-center justify-center mb-4 sm:mb-6 text-2xl sm:text-3xl">
                  💧
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                  Resistente al agua
                </h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Perfecto para momentos íntimos en la ducha o bañera. Expande tus horizontes de placer.
                </p>
              </div>

              {/* Benefit 5 */}
              <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-fuchsia-500 to-pink-500 rounded-2xl flex items-center justify-center mb-4 sm:mb-6 text-2xl sm:text-3xl">
                  🔋
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                  Recargable vía USB
                </h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Siempre listo, sin pilas ni cables incómodos. Carga completa en pocas horas para semanas de uso.
                </p>
              </div>

              {/* Benefit 6 - Bonus */}
              <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-fuchsia-500 to-pink-500 rounded-2xl flex items-center justify-center mb-4 sm:mb-6 text-2xl sm:text-3xl">
                  🎯
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                  11 niveles de intensidad
                </h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Desde suave hasta intenso. Encuentra tu ritmo perfecto y personaliza cada sesión a tu gusto.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section id="video-section" className="py-12 sm:py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-8 sm:mb-12">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-2">
                Mira cómo funciona el Satisfyer Pro 2
              </h2>
              <p className="text-base sm:text-xl text-gray-700 px-4">
                Review completa y honesta para que descubras todo lo que necesitas saber
              </p>
            </div>
            
            <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl bg-gray-900 mx-2 sm:mx-0" style={{ paddingBottom: '56.25%' }}>
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/FqP1UFgROoM"
                title="Satisfyer Pro 2 Review"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-12 sm:py-20 bg-gradient-to-br from-pink-50 to-fuchsia-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center text-gray-900 mb-10 sm:mb-16 px-2">
              Lo que dicen nuestras clientas
            </h2>
            
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {/* Testimonial 1 */}
              <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-xl">
                <div className="flex items-center gap-1 mb-3 sm:mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-fuchsia-500 text-lg sm:text-xl"></i>
                  ))}
                </div>
                <p className="text-gray-800 text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed italic">
                  "Pensé que era una exageración… hasta que lo probé. Brutal. No hay palabras para describir lo que se siente."
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-fuchsia-400 to-pink-400 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                    M
                  </div>
                  <div className="min-w-0">
                    <p className="font-bold text-gray-900 text-sm sm:text-base">María</p>
                    <p className="text-xs sm:text-sm text-gray-600">Madrid, España</p>
                  </div>
                </div>
              </div>

              {/* Testimonial 2 */}
              <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-xl">
                <div className="flex items-center gap-1 mb-3 sm:mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-fuchsia-500 text-lg sm:text-xl"></i>
                  ))}
                </div>
                <p className="text-gray-800 text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed italic">
                  "Lo uso casi a diario. Es discreto, rápido y me hace sentir increíble. Mi momento favorito del día."
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-fuchsia-400 to-pink-400 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                    L
                  </div>
                  <div className="min-w-0">
                    <p className="font-bold text-gray-900 text-sm sm:text-base">Laura</p>
                    <p className="text-xs sm:text-sm text-gray-600">Buenos Aires, Argentina</p>
                  </div>
                </div>
              </div>

              {/* Testimonial 3 */}
              <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-xl">
                <div className="flex items-center gap-1 mb-3 sm:mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-fuchsia-500 text-lg sm:text-xl"></i>
                  ))}
                </div>
                <p className="text-gray-800 text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed italic">
                  "Mi mejor compra del año. Literalmente no puedo vivir sin él. Se lo recomiendo a todas mis amigas."
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-fuchsia-400 to-pink-400 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                    S
                  </div>
                  <div className="min-w-0">
                    <p className="font-bold text-gray-900 text-sm sm:text-base">Sofía</p>
                    <p className="text-xs sm:text-sm text-gray-600">Ciudad de México, México</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center text-gray-900 mb-10 sm:mb-16 px-2">
              Preguntas frecuentes
            </h2>
            
            <div className="space-y-4">
              {/* FAQ 1 */}
              <div className="bg-gradient-to-br from-fuchsia-50 to-pink-50 rounded-2xl overflow-hidden shadow-lg">
                <button
                  onClick={() => toggleFaq(0)}
                  className="w-full px-4 sm:px-8 py-4 sm:py-6 flex items-center justify-between text-left hover:bg-white/50 transition-colors cursor-pointer"
                  aria-expanded={openFaq === 0}
                  aria-controls="faq-answer-0"
                >
                  <div className="flex items-center gap-2 sm:gap-4 min-w-0 flex-1 pr-2">
                    <span className="text-xl sm:text-2xl flex-shrink-0">❓</span>
                    <h3 className="text-base sm:text-xl font-bold text-gray-900 break-words">
                      ¿Hace ruido?
                    </h3>
                  </div>
                  <i className={`ri-arrow-${openFaq === 0 ? 'up' : 'down'}-s-line text-xl sm:text-2xl text-fuchsia-600 transition-transform flex-shrink-0`}></i>
                </button>
                {openFaq === 0 && (
                  <div id="faq-answer-0" className="px-4 sm:px-8 pb-4 sm:pb-6">
                    <div className="flex items-start gap-2 sm:gap-3 bg-white rounded-xl p-4 sm:p-6">
                      <span className="text-xl sm:text-2xl flex-shrink-0">✅</span>
                      <p className="text-gray-700 text-sm sm:text-lg leading-relaxed break-words">
                        No, es muy silencioso. Puedes usarlo incluso con gente cerca sin preocuparte. El motor está diseñado para ser ultra discreto.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* FAQ 2 */}
              <div className="bg-gradient-to-br from-fuchsia-50 to-pink-50 rounded-2xl overflow-hidden shadow-lg">
                <button
                  onClick={() => toggleFaq(1)}
                  className="w-full px-4 sm:px-8 py-4 sm:py-6 flex items-center justify-between text-left hover:bg-white/50 transition-colors cursor-pointer"
                  aria-expanded={openFaq === 1}
                  aria-controls="faq-answer-1"
                >
                  <div className="flex items-center gap-2 sm:gap-4 min-w-0 flex-1 pr-2">
                    <span className="text-xl sm:text-2xl flex-shrink-0">❓</span>
                    <h3 className="text-base sm:text-xl font-bold text-gray-900 break-words">
                      ¿Es fácil de limpiar?
                    </h3>
                  </div>
                  <i className={`ri-arrow-${openFaq === 1 ? 'up' : 'down'}-s-line text-xl sm:text-2xl text-fuchsia-600 transition-transform flex-shrink-0`}></i>
                </button>
                {openFaq === 1 && (
                  <div id="faq-answer-1" className="px-4 sm:px-8 pb-4 sm:pb-6">
                    <div className="flex items-start gap-2 sm:gap-3 bg-white rounded-xl p-4 sm:p-6">
                      <span className="text-xl sm:text-2xl flex-shrink-0">✅</span>
                      <p className="text-gray-700 text-sm sm:text-lg leading-relaxed break-words">
                        Sí, solo retira el cabezal y lávalo con agua y jabón neutro. Al ser resistente al agua, la limpieza es súper sencilla e higiénica.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* FAQ 3 */}
              <div className="bg-gradient-to-br from-fuchsia-50 to-pink-50 rounded-2xl overflow-hidden shadow-lg">
                <button
                  onClick={() => toggleFaq(2)}
                  className="w-full px-4 sm:px-8 py-4 sm:py-6 flex items-center justify-between text-left hover:bg-white/50 transition-colors cursor-pointer"
                  aria-expanded={openFaq === 2}
                  aria-controls="faq-answer-2"
                >
                  <div className="flex items-center gap-2 sm:gap-4 min-w-0 flex-1 pr-2">
                    <span className="text-xl sm:text-2xl flex-shrink-0">❓</span>
                    <h3 className="text-base sm:text-xl font-bold text-gray-900 break-words">
                      ¿Duele si nunca he usado uno?
                    </h3>
                  </div>
                  <i className={`ri-arrow-${openFaq === 2 ? 'up' : 'down'}-s-line text-xl sm:text-2xl text-fuchsia-600 transition-transform flex-shrink-0`}></i>
                </button>
                {openFaq === 2 && (
                  <div id="faq-answer-2" className="px-4 sm:px-8 pb-4 sm:pb-6">
                    <div className="flex items-start gap-2 sm:gap-3 bg-white rounded-xl p-4 sm:p-6">
                      <span className="text-xl sm:text-2xl flex-shrink-0">✅</span>
                      <p className="text-gray-700 text-sm sm:text-lg leading-relaxed break-words">
                        No, es una estimulación suave y sin contacto directo, perfecta incluso para principiantes. Empieza con el nivel más bajo y ve subiendo a tu ritmo.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* FAQ 4 */}
              <div className="bg-gradient-to-br from-fuchsia-50 to-pink-50 rounded-2xl overflow-hidden shadow-lg">
                <button
                  onClick={() => toggleFaq(3)}
                  className="w-full px-4 sm:px-8 py-4 sm:py-6 flex items-center justify-between text-left hover:bg-white/50 transition-colors cursor-pointer"
                  aria-expanded={openFaq === 3}
                  aria-controls="faq-answer-3"
                >
                  <div className="flex items-center gap-2 sm:gap-4 min-w-0 flex-1 pr-2">
                    <span className="text-xl sm:text-2xl flex-shrink-0">❓</span>
                    <h3 className="text-base sm:text-xl font-bold text-gray-900 break-words">
                      ¿Viene con cargador?
                    </h3>
                  </div>
                  <i className={`ri-arrow-${openFaq === 3 ? 'up' : 'down'}-s-line text-xl sm:text-2xl text-fuchsia-600 transition-transform flex-shrink-0`}></i>
                </button>
                {openFaq === 3 && (
                  <div id="faq-answer-3" className="px-4 sm:px-8 pb-4 sm:pb-6">
                    <div className="flex items-start gap-2 sm:gap-3 bg-white rounded-xl p-4 sm:p-6">
                      <span className="text-xl sm:text-2xl flex-shrink-0">✅</span>
                      <p className="text-gray-700 text-sm sm:text-lg leading-relaxed break-words">
                        Sí, incluye cable USB para recargar fácilmente. Compatible con cualquier adaptador USB estándar o puerto de ordenador.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 sm:py-24 bg-gradient-to-br from-fuchsia-600 via-pink-600 to-rose-600 relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4xIj48cGF0aCBkPSJNMzYgMzRjMC0yLjIxLTEuNzktNC00LTRzLTQgMS43OS00IDQgMS43OSA0IDQgNCA0LTEuNzkgNC00em0wLTEwYzAtMi4yMS0xLjc5LTQtNC00cy00IDEuNzktNCA0IDEuNzkgNCA0IDQgNC0xLjc5IDQtNHptMC0xMGMwLTIuMjEtMS43OS00LTQtNHMtNCAxLjc5LTQgNCAxLjc5IDQgNCA0IDQtMS43OSA0LTR6Ii8+PC9nPjwvZz48L3N2Zz4=')] opacity-20"></div>
        
        <div className="container mx-auto px-4 sm:px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl sm:text-4xl md:text-6xl font-bold text-white mb-4 sm:mb-6 px-2">
              Hazte un regalo inolvidable
            </h2>
            <p className="text-base sm:text-xl md:text-2xl text-white/90 mb-8 sm:mb-12 leading-relaxed px-4">
              El Satisfyer Pro 2 puede cambiar tus noches para siempre.<br className="hidden sm:inline" />
              Únete a millones de mujeres que ya lo disfrutan.
            </p>
            
            <a 
              href="https://amzn.to/4s8i8sI" 
              target="_blank" 
              rel="nofollow noopener noreferrer"
              className="inline-block w-full sm:w-auto px-8 sm:px-12 py-5 sm:py-6 bg-white text-fuchsia-600 text-lg sm:text-xl font-bold rounded-full shadow-2xl hover:shadow-white/50 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer mx-4 sm:mx-0"
            >
              Comprar ahora en Amazon
              <i className="ri-arrow-right-line ml-2"></i>
            </a>

            <div className="mt-8 sm:mt-12 flex flex-wrap justify-center gap-4 sm:gap-6 text-white/80 text-xs sm:text-sm px-4">
              <div className="flex items-center gap-2">
                <i className="ri-truck-line text-lg sm:text-xl flex-shrink-0"></i>
                <span className="whitespace-nowrap">Envío rápido</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-lg sm:text-xl flex-shrink-0"></i>
                <span className="whitespace-nowrap">Garantía oficial</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-lock-line text-lg sm:text-xl flex-shrink-0"></i>
                <span className="whitespace-nowrap">Pago seguro</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-box-3-line text-lg sm:text-xl flex-shrink-0"></i>
                <span className="whitespace-nowrap">Embalaje discreto</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 sm:py-16">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-6xl mx-auto">
            {/* Affiliate Notice */}
            <div className="bg-gray-800 rounded-2xl p-6 sm:p-8 mb-8 sm:mb-12 border border-gray-700">
              <div className="flex items-start gap-3 sm:gap-4">
                <i className="ri-information-line text-2xl sm:text-3xl text-fuchsia-400 flex-shrink-0"></i>
                <div className="min-w-0">
                  <h3 className="text-base sm:text-lg font-bold mb-2 text-fuchsia-400">Aviso de afiliación</h3>
                  <p className="text-sm sm:text-base text-gray-300 leading-relaxed break-words">
                    Esta página contiene enlaces de afiliado de Amazon. Si realizas una compra a través de estos enlaces, podemos recibir una comisión sin coste adicional para ti. Esto nos ayuda a mantener el contenido gratuito y de calidad.
                  </p>
                </div>
              </div>
            </div>

            {/* Age Warning */}
            <div className="bg-rose-900/30 rounded-2xl p-6 sm:p-8 mb-8 sm:mb-12 border border-rose-700/50">
              <div className="flex items-start gap-3 sm:gap-4">
                <i className="ri-error-warning-line text-2xl sm:text-3xl text-rose-400 flex-shrink-0"></i>
                <div className="min-w-0">
                  <h3 className="text-base sm:text-lg font-bold mb-2 text-rose-400">Contenido para adultos (+18)</h3>
                  <p className="text-sm sm:text-base text-gray-300 leading-relaxed break-words">
                    Este sitio web contiene información sobre productos para adultos. Debes ser mayor de 18 años para acceder a este contenido.
                  </p>
                </div>
              </div>
            </div>

            {/* Footer Links */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-8 sm:mb-12">
              <div>
                <img 
                  src="https://public.readdy.ai/ai/img_res/18821062-5580-489b-bd88-b2fb95f30ddd.png" 
                  alt="Conejox Logo" 
                  className="h-8 sm:h-10 w-auto object-contain mb-3 sm:mb-4"
                  width="100"
                  height="40"
                  loading="lazy"
                />
                <p className="text-gray-400 text-xs sm:text-sm leading-relaxed break-words">
                  Tu guía de confianza para productos de bienestar íntimo y placer femenino.
                </p>
              </div>

              <div>
                <h4 className="font-bold text-base sm:text-lg mb-3 sm:mb-4 text-fuchsia-400">Legal</h4>
                <ul className="space-y-2 text-gray-400 text-xs sm:text-sm">
                  <li>
                    <a href="#aviso-legal" className="hover:text-fuchsia-400 transition-colors cursor-pointer break-words">
                      Aviso Legal
                    </a>
                  </li>
                  <li>
                    <a href="#privacidad" className="hover:text-fuchsia-400 transition-colors cursor-pointer break-words">
                      Política de Privacidad
                    </a>
                  </li>
                  <li>
                    <a href="#cookies" className="hover:text-fuchsia-400 transition-colors cursor-pointer break-words">
                      Política de Cookies
                    </a>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="font-bold text-base sm:text-lg mb-3 sm:mb-4 text-fuchsia-400">Contacto</h4>
                <ul className="space-y-2 text-gray-400 text-xs sm:text-sm">
                  <li>
                    <a href="#contact-form" className="hover:text-fuchsia-400 transition-colors cursor-pointer break-words">
                      Formulario de contacto
                    </a>
                  </li>
                  <li>
                    <a href="mailto:info@conejox.com.es" className="hover:text-fuchsia-400 transition-colors cursor-pointer break-all">
                      info@conejox.com.es
                    </a>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="font-bold text-base sm:text-lg mb-3 sm:mb-4 text-fuchsia-400">Síguenos</h4>
                <div className="flex gap-3">
                  <a href="#instagram" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-fuchsia-600 transition-colors cursor-pointer flex-shrink-0" aria-label="Instagram">
                    <i className="ri-instagram-line text-xl"></i>
                  </a>
                  <a href="#tiktok" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-fuchsia-600 transition-colors cursor-pointer flex-shrink-0" aria-label="TikTok">
                    <i className="ri-tiktok-line text-xl"></i>
                  </a>
                  <a href="#twitter" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-fuchsia-600 transition-colors cursor-pointer flex-shrink-0" aria-label="Twitter">
                    <i className="ri-twitter-x-line text-xl"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Copyright */}
            <div className="border-t border-gray-800 pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4 text-xs sm:text-sm text-gray-400">
              <p className="text-center sm:text-left break-words">© 2025 Conejox.com.es – Todos los derechos reservados.</p>
              <a 
                href="https://conejox.com.es/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-fuchsia-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                Powered by Conejox
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-6 right-6 sm:bottom-8 sm:right-8 w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-fuchsia-600 to-pink-600 text-white rounded-full shadow-2xl hover:shadow-fuchsia-500/50 transition-all duration-300 hover:scale-110 flex items-center justify-center z-50 cursor-pointer"
        aria-label="Volver arriba"
      >
        <i className="ri-arrow-up-line text-xl sm:text-2xl"></i>
      </button>
    </div>
  );
}
